var exports = {
  "dL": "GuildHeader.module__headerWrapper___YzJhWH",
  "N1": "GuildHeader.module__headerContainer___YzJhWH",
  "bp": "GuildHeader.module__headerContainerActive___YzJhWH",
  "vf": "GuildHeader.module__headerContainerBanner___YzJhWH",
  "Le": "GuildHeader.module__headerContainerCollapsing___YzJhWH",
  "On": "GuildHeader.module__headerContainerNoBanner___YzJhWH",
  "nL": "GuildHeader.module__bannerClip___YzJhWH",
  "_e": "GuildHeader.module__bannerImage___YzJhWH",
  "Oo": "GuildHeader.module__bannerImageCentered___YzJhWH",
  "iI": "GuildHeader.module__headerGlass___YzJhWH",
  "nY": "GuildHeader.module__bannerGradient___YzJhWH",
  "VW": "GuildHeader.module__headerContent___YzJhWH",
  "KZ": "GuildHeader.module__headerFocusRing___YzJhWH",
  "Ve": "GuildHeader.module__verifiedIconDefault___YzJhWH" + " " + "GuildHeader.module__verifiedIcon___YzJhWH",
  "K8": "GuildHeader.module__guildNameDefault___YzJhWH" + " " + "GuildHeader.module__guildName___YzJhWH",
  "rr": "GuildHeader.module__guildNameWithBanner___YzJhWH" + " " + "GuildHeader.module__guildName___YzJhWH",
  "Ic": "GuildHeader.module__caretIconDefault___YzJhWH" + " " + "GuildHeader.module__caretIcon___YzJhWH",
  "Tu": "GuildHeader.module__caretIconWithBanner___YzJhWH" + " " + "GuildHeader.module__caretIcon___YzJhWH",
  "xu": "GuildHeader.module__caretIconOpen___YzJhWH",
  "D1": "GuildHeader.module__dotsIconDefault___YzJhWH" + " " + "GuildHeader.module__dotsIcon___YzJhWH",
  "GX": "GuildHeader.module__dotsIconWithBanner___YzJhWH" + " " + "GuildHeader.module__dotsIcon___YzJhWH",
};

module.exports = exports;
